/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'ai-mate.agent-header-banner-label': 'Banner de agente',
  'ai-mate.agent-list.all-agents-section-title': 'Todos los agentes',
  'ai-mate.agent-list.beta-lozenge-title': 'Beta',
  'ai-mate.agent-list.change-owner-success-flag-description':
    'Has cambiado el propietario de {agentName} a {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Propietario cambiado correctamente',
  'ai-mate.agent-list.delete-agent-confirm-body':
    '¿Seguro que quieres eliminar este agente? Esta acción no se puede deshacer.',
  'ai-mate.agent-list.delete-agent-confirm-title': '¿Quieres eliminar a "{agentName}"?',
  'ai-mate.agent-list.delete-agent-error': 'No se ha podido eliminar el agente',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'Se ha producido un error al eliminar al agente. Inténtalo de nuevo en unos instantes.',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'Error al eliminar al agente',
  'ai-mate.agent-list.delete-agent-error.agent-in-use':
    'El agente está actualmente en uso. Vuelve a intentarlo más tarde.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'No se ha podido localizar a ese agente.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'No puedes eliminar agentes que tú no has creado. Ponte en contacto con el propietario del agente.',
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Has eliminado {agentName}',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Agente eliminado',
  'ai-mate.agent-list.development-section-title': 'Agentes de desarrollo',
  'ai-mate.agent-list.load-more-button-loading': 'Cargando más agentes...',
  'ai-mate.agent-list.load-more-button-ready': 'Cargar más',
  'ai-mate.agent-list.loading-agents': 'Cargando agentes...',
  'ai-mate.agent-list.no-results': 'No se ha encontrado ningún resultado para "{searchValue}"',
  'ai-mate.agent-list.recommended-agents-section-title': 'Recomendado',
  'ai-mate.agent-list.searching-agents': 'Buscando agentes...',
  'ai-mate.agent-list.templates-description':
    'Usa estas plantillas para crear tu agente desarrollador. Elige la plantilla de agente adecuada para tu trabajo, selecciona Usar plantilla y, a continuación, rellena la instrucción de la plantilla con detalles específicos, como el repositorio, la carpeta, el idioma y la biblioteca. Crea agentes de desarrollo a medida para codificar diferentes tareas, proyectos o repositorios.',
  'ai-mate.agent-list.templates-lozenge-title': 'Plantilla',
  'ai-mate.agent-list.templates-title': 'Plantillas de codificación',
  'ai-mate.agent-message.agent-not-found': 'No se ha encontrado el agente',
  'ai-mate.agent-message.convo-title': 'Chatear con {agentName} activado desde un enlace inteligente integrado',
  'ai-mate.agent-message.copy-link': 'Copiar enlace de agente',
  'ai-mate.agent-message.prompt': 'Indicación',
  'ai-mate.agent-message.prompt-placeholder': 'Escribe un mensaje para {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Enviar',
  'ai-mate.agent-message.view-profile': 'Ver perfil',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Cancelar',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Eliminar',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agente · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Hablar con {agentName}',
  'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip': 'URL copiada',
  'ai-mate.agent-profile-info.copy-agent-link-tooltip': 'Copiar enlace',
  'ai-mate.agent-profile-info.hidden-icon': 'Oculto',
  'ai-mate.agent-profile-info.hidden-tooltip': 'El agente no se mostrará en los resultados de búsqueda',
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Se marcará al agente como favorito',
  'ai-mate.agent-selector.agent-not-found': 'No se ha encontrado el agente',
  'ai-mate.agent-selector.default-agent-description':
    'Obtén respuestas, genera nuevas ideas y acelera el trabajo diario.',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.browse-agents-view.close-button': 'Cerrar la vista de agentes',
  'ai-mate.profile-card-preview.actions-title': 'Acciones',
  'ai-mate.profile-card-preview.agent-default-title': 'Agente',
  'ai-mate.profile-card-preview.agent-description-label': 'Descripción',
  'ai-mate.profile-card-preview.agent-title-label': 'Título',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Inicios de conversación',
  'ai-mate.profile-card-preview.empty-actions': 'Ninguno',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'Ninguno',
  'ai-mate.profile-card-preview.empty-instructions': 'Ninguno',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Ninguno seleccionado',
  'ai-mate.profile-card-preview.instructions-title': 'Instrucciones',
  'ai-mate.profile-card-preview.knowledge-title': 'Conocimiento',
  'ai-mate.profile-card-preview.regenerate-label': 'Volver a generar {fieldName}',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} (copia)',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'Arrastra para reordenar',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'No se han podido guardar los cambios',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Se ha producido un error desconocido. Inténtalo de nuevo.',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Ya existe un agente con este nombre',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Eliminar',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text':
    'Generar inicios de conversación',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {{fieldName} no puede superar {maxLength,number} carácter} other {{fieldName} no puede superar los {maxLength,number} caracteres}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Siguiente',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Reiniciar',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'Saltar a la configuración manual',
  'create-agent.owner-field.confirm-modal-cancel': 'Cancelar',
  'create-agent.owner-field.confirm-modal-confirm': 'Sí, continuar',
  'create-agent.owner-field.confirm-modal-content':
    'Estás a punto de cambiar el propietario de este agente a {name}. Al hacerlo, no podrás volver a editar o gestionar este agente.',
  'create-agent.owner-field.confirm-modal-title': 'Estás a punto de perder el acceso de edición',
  'create-agent.owner-field.owner-description': 'Esta es la persona que puede editar o gestionar al agente.',
  'create-agent.owner-field.owner-label': 'Propietario',
  'rovo-chat.agent-card.deactivated-name': '{name} (desactivado)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'Hay demasiadas solicitudes. Espera un momento.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Volver a intentarlo',
  'rovo-chat.browse-agents.all-agents-button': 'Todos',
  'rovo-chat.browse-agents.close-button': 'Cerrar',
  'rovo-chat.browse-agents.create-agent-button': 'Crear',
  'rovo-chat.browse-agents.create-an-agent-button': 'Crear un agente',
  'rovo-chat.browse-agents.create-button-disabled-tooltip': 'No tienes permiso para crear agentes en este sitio',
  'rovo-chat.browse-agents.created-by-label': '<text>de</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Agentes de codificación',
  'rovo-chat.browse-agents.favorite-agents-button': 'Favoritos',
  'rovo-chat.browse-agents.favourited-agent-label': 'Agente favorito',
  'rovo-chat.browse-agents.modal-title': 'Buscar agentes',
  'rovo-chat.browse-agents.my-agents-button': 'Mis agentes',
  'rovo-chat.browse-agents.no-created-agents':
    'Parece que aún no has creado ningún agente. Empieza por duplicar otros agentes existentes o parte desde cero para crear uno.',
  'rovo-chat.browse-agents.no-created-agents-header': 'Aún no se ha creado ningún agente',
  'rovo-chat.browse-agents.no-created-agents-header-no-permission': 'No has creado ningún agente.',
  'rovo-chat.browse-agents.no-created-agents-no-permission':
    'Necesitas el permiso de un administrador para crear Agentes Rovo en este sitio.',
  'rovo-chat.browse-agents.no-starred-agents':
    'Si tienes un agente favorito o uno que utilices con frecuencia, márcalo como favorito para acceder fácilmente.',
  'rovo-chat.browse-agents.no-starred-agents-header': 'Aún no has marcado ningún agente como favorito',
  'rovo-chat.browse-agents.search-input.placeholder': 'Agentes de búsqueda',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Buscar plantillas',
  'rovo-chat.browse-agents.see-all-agents-button': 'Ver todos los agentes',
  'rovo-chat.browse-agents.templates-button': 'Plantillas',
  'rovo-chat.create-agent.actions-section-description':
    'Añade acciones para que tu agente lleve a cabo tareas en Jira, Confluence y Jira Service Management. <link>¿Qué son las acciones de los agentes?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Añadir acciones',
  'rovo-chat.create-agent.all-content-label': 'Todo el contenido',
  'rovo-chat.create-agent.back-button': 'Regresar',
  'rovo-chat.create-agent.confirm-leave-modal.body': 'Todavía no has creado tu agente, ¿quieres descartarlo?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Cancelar',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Sí, descartar agente',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    '¿Seguro que quieres descartar los cambios realizados en este agente?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Confirmar',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Reiniciar tu creación',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'Pueden utilizarse para iniciar una conversación con el agente. Si no se te ocurre ninguno, podemos generarlo por ti.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Inicios de conversación',
  'rovo-chat.create-agent.create-agent-button': 'Crear',
  'rovo-chat.create-agent.ctions-section-title': 'Acciones',
  'rovo-chat.create-agent.description-field-description':
    'Las personas pueden usar la descripción del perfil del agente para obtener más información al respecto.',
  'rovo-chat.create-agent.description-field-label': 'Descripción',
  'rovo-chat.create-agent.description-field-placeholder':
    'Escribe una descripción breve de tu agente (por ejemplo, redactor creativo para blogs de marketing)',
  'rovo-chat.create-agent.instructions-field-description':
    '¿Cómo quieres que se comporte el agente? ¿Qué puede hacer? <link>Más información sobre cómo escribir instrucciones para un agente</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Instrucciones',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Personaliza las instrucciones para este agente',
  'rovo-chat.create-agent.intro-description-part-1':
    'Crea un agente con conocimientos especializados para responder preguntas, escribir y revisar el contenido, y realizar tareas que te ayude a sacar el trabajo adelante.',
  'rovo-chat.create-agent.intro-description-part-2':
    'Si no necesitas ayuda, puedes <bold>Saltar a la configuración manual.</bold>',
  'rovo-chat.create-agent.intro-description-part-3': 'Si no, quédate aquí para hacerlo juntos.',
  'rovo-chat.create-agent.intro-step-1-content':
    'Crearé instrucciones para el agente basándome en lo que escribas. Solo dime para qué quieres usar el agente.',
  'rovo-chat.create-agent.intro-step-1-title': 'Describe lo que quieras que haga tu agente',
  'rovo-chat.create-agent.intro-step-2-content':
    'Decidamos juntos el nombre y la personalidad de tu agente. Dime si tu agente es empático, directo o divertido.',
  'rovo-chat.create-agent.intro-step-2-title': 'Dale un toque de personalidad',
  'rovo-chat.create-agent.intro-step-3-content':
    'Pulsa <bold>Siguiente</bold> para revisar tu nuevo agente, añadir acciones, conocimientos y una foto de perfil. Cuando hayas terminado, selecciona <bold>Crear.</bold>',
  'rovo-chat.create-agent.intro-step-3-content-skills':
    'Pulsa <bold>Siguiente</bold> para revisar tu nuevo agente, añadir destrezas, conocimientos y una foto de perfil. Cuando hayas terminado, selecciona <bold>Crear.</bold>',
  'rovo-chat.create-agent.intro-step-3-title': 'Revisa y crea tu agente',
  'rovo-chat.create-agent.intro-title': '👋 Creemos tu agente',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Todos los proyectos',
  'rovo-chat.create-agent.jira-filter-placeholder-galaxia': 'Todos los espacios',
  'rovo-chat.create-agent.jsm-checkbox-label': 'Jira Service Management',
  'rovo-chat.create-agent.knowledge-field-description':
    'Especifica los conocimientos del agente permitiéndole hacer referencia solamente a las fuentes que le proporciones',
  'rovo-chat.create-agent.knowledge-field-label': 'Conocimiento',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Solo hacer referencia a estas fuentes',
  'rovo-chat.create-agent.knowledge-select.object-resolver-label': 'Enlaces',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Sugeridos',
  'rovo-chat.create-agent.manage-actions-button-label': 'Gestionar acciones',
  'rovo-chat.create-agent.name-field-description': 'Puede usarse para encontrar al agente.',
  'rovo-chat.create-agent.name-field-label': 'Nombre',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error':
    'Se ha producido un error inesperado. Vuelve a intentarlo.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    '¡Hola! Estoy aquí para ayudarte a crear un agente personalizado. Dime qué te gustaría que hiciera tu agente.',
  'rovo-chat.create-agent.nl-input-field.input-label': 'Crear un agente',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Escribe tu mensaje',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Enviar',
  'rovo-chat.create-agent.page-title': 'Crear un agente',
  'rovo-chat.create-agent.page-title-edit': 'Editar agente',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Buscar páginas',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Buscar espacios',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Todos',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Beta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Cancelar',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Cerrar',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Seleccionar menos de {count,number} acción permite un rendimiento óptimo} other {Seleccionar menos de {count,number} acciones permite un rendimiento óptimo}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Guardar',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Buscar acciones',
  'rovo-chat.create-agent.select-action-modal-title': 'Añadir acciones',
  'rovo-chat.create-agent.select-content-under-label': 'Seleccionar el contenido de',
  'rovo-chat.create-agent.select-spaces-label': 'Seleccionar espacios',
  'rovo-chat.create-agent.selected-actions-label': 'Acciones seleccionadas:',
  'rovo-chat.create-agent.unknown-owner': 'Desconocido',
  'rovo-chat.create-agent.update-agent-button': 'Actualizar',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Si continúas, perderás los cambios sin guardar. Selecciona Cancelar para seguir editando este agente.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Continuar y descartar cambios',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Descartar cambios',
  'rovo-chat.view-agent.about-label': 'Acerca de',
  'rovo-chat.view-agent.actions-label': 'Acciones',
  'rovo-chat.view-agent.all-knowledge-added': 'Todos los conocimientos de la organización',
  'rovo-chat.view-agent.behaviour-label': 'Comportamiento',
  'rovo-chat.view-agent.beta-label': 'Beta',
  'rovo-chat.view-agent.beta-tag': 'Beta',
  'rovo-chat.view-agent.chat-to-agent-button': 'Hablar con el agente',
  'rovo-chat.view-agent.close-button': 'Cerrar',
  'rovo-chat.view-agent.copy-behaviour-tooltip': 'Copiar el comportamiento',
  'rovo-chat.view-agent.copy-instructions-label': 'Copiar',
  'rovo-chat.view-agent.copy-instructions-tooltip': 'Copiar instrucciones',
  'rovo-chat.view-agent.created-by-label': '<text>de</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': '# de favoritos',
  'rovo-chat.view-agent.go-back-label': 'Volver',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Los agentes de Forge creados con código tienen sus instrucciones ocultas por motivos de privacidad.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Instrucciones privadas',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'Los agentes de Forge creados con código no utilizan las fuentes de conocimiento típicas',
  'rovo-chat.view-agent.instructions-label': 'Instrucciones',
  'rovo-chat.view-agent.knowledge-label': 'Conocimiento',
  'rovo-chat.view-agent.member-count': '{count, plural, one {{count,number} miembro} other {{count,number} miembros}}',
  'rovo-chat.view-agent.modal-title': 'Buscar agentes',
  'rovo-chat.view-agent.no-actions': 'Sin acciones',
  'rovo-chat.view-agent.no-behaviour-placeholder': 'Este agente no tiene un comportamiento personalizado',
  'rovo-chat.view-agent.no-instruction-placeholder': 'Este agente no tiene instrucciones personalizadas',
  'rovo-chat.view-agent.no-knowledge-added': 'No hay conocimientos de la organización',
  'rovo-chat.view-agent.no-scenarios': 'No hay escenarios',
  'rovo-chat.view-agent.no-skills': 'No hay destrezas',
  'rovo-chat.view-agent.no-teams': 'No forma parte de ningún equipo',
  'rovo-chat.view-agent.open-chat-label': 'Abrir chat',
  'rovo-chat.view-agent.reactions-metadata-label': '# de reacciones',
  'rovo-chat.view-agent.rovo-agent-label': 'Agente Rovo',
  'rovo-chat.view-agent.scenarios-label': 'Escenarios',
  'rovo-chat.view-agent.skills-label': 'Destrezas',
  'rovo-chat.view-agent.teams-label': 'Equipos',
  'rovo-chat.view-agent.users-metadata-label': '# de usuarios',
};
